<template>
    <div class='official-business-container'>
        <img src="../../../public/static/images/official/business/1.png" alt="">
        <img src="../../../public/static/images/official/business/2.png" alt="">
    </div>
</template>

<script>

export default {
    name: '',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {},
}
</script>
<style lang='less' scoped>
.official-business-container {

    font-size: 0;

    img {
        width: 100%;
        vertical-align: top;
        margin-top: -2px;
    }
}
</style>